<template>
	<div class="el-collapse-item" :class="{ 'is-active': activeState }">
		<button type="button" class="el-collapse-item__header" :class="{ 'is-active': activeState }" @click="toggleActive">
			<slot name="title">{{ title }}</slot>
			<el-icon class="el-collapse-item__arrow" :class="{ 'is-active': activeState }">
				<ArrowRight />
			</el-icon>
	    </button>

		<el-collapse-transition>
			<div v-show="activeState" class="el-collapse-item__wrap">
				<div class="el-collapse-item__content">
					<slot />
				</div>
			</div>
	    </el-collapse-transition>
	</div>
</template>

<script>
import { ArrowRight } from '@element-plus/icons-vue'

export default {
	components: {
		ArrowRight,
	},
	emits: ['change'],
	props: {
		title: {
			type: String,
			default: '',
		},
		header: {
			type: String,
			default: '',
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			activeState: this.isActive,
		};
	},
	methods: {
		toggleActive() {
			this.activeState = !this.activeState;
			this.$emit('change', this.activeState);
		},
	},
	watch: {
		isActive(newVal) {
			this.activeState = newVal;
		},
	},
};
</script>

<style scoped>
.el-collapse-item {
    border: 1px solid #BABABA;
    background-color: #7474740D;
    border-radius: 8px;
}

.el-collapse-item__header {
    height: 38px;
    display: flex;
    padding: 0 15px;
    border-bottom: 1px solid #BABABA;
}

.el-collapse-item__header:hover {
    border-bottom-color: #BABABA !important;
    background-color: transparent !important;
}

.el-collapse-item__header.is-active {
    border-bottom-color: #BABABA;
}

.el-collapse-item__arrow {
    margin-right: 0;
    margin-left: auto;
    font-size: 24px;
    font-weight: bold;
    transform: scale(1);
	transform: rotate(90deg);
}

.el-collapse-item__header:not(.is-active) {
    border-bottom: none;
}

.el-collapse-item__arrow.is-active {
    transform: rotate(270deg);
}

.el-collapse-item__content {
    padding: 15px;
}
</style>

